import React from 'react'

// Components
import { TextField } from '@mui/material'

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import CloseIcon from '@mui/icons-material/Close';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import CheckIcon from '@mui/icons-material/Check';
// Component Date
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/es';
import dayjs from "dayjs";

import { FormHelperText } from '@mui/material';

// Styles
import { Label, ContainerInput, ContainerGroup, ContainerContent, ContainerBox, ContainerChecks, CustomCheckbox, ContainerInputsDate, ContainerSelect, ContainerIcon, ContainerCertificates, UploadButton, ContainerUpload, ContainerElectricalTechnician, ContainerElectricalTechnicianFields } from './styles'

// Utils
import { useTranslation } from 'react-i18next'
import { SelectInput } from '../../../SelectInput'

// Link
import Link from '@mui/material/Link';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { ColorsContext } from '../../../../Context/ColorsContext';

const mapeoStatusIcons = {
    active: {
        color: '#4CAF50',
        icon: CheckIcon,
    },
    loading: {
        color: '#FFB74D',
        icon: HourglassTopIcon,
    },
    error: {
        color: '#E57373',
        icon: CloseIcon,
    },
};

function renderIcon(status) {
    const statusConfig = mapeoStatusIcons[status] || {};
    const IconComponent = statusConfig.icon || null;
    const color = statusConfig.color || 'gray';

    if (!IconComponent) return null;

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: color,
                borderRadius: '50%',
                width: '24px',
                height: '24px',
            }}
        >
            <IconComponent style={{ color: 'white', fontSize: '16px' }} />
        </div>
    );
}

export const CompanyWorkerForms = ({
    isEdit, form, errors, disabled, specialties, assignations, handleChange, handleChangeCertificates, arrayEps, arrayArl, 
	isRetieTechnicalCertificate, arrayRoleElectricalLevels, handleChangeFile
}) => {
    const { t } = useTranslation();
	const { colors } = React.useContext(ColorsContext);

    return (
        <ContainerBox>
            <ContainerContent>
                <ContainerGroup>
                    <ContainerInput sx={{ width: '25%' }}>
                        <Label>{t('worker.table.identification')}:</Label>
                        <TextField
                            type='number'
                            value={form.identification}
                            size="small"
                            onChange={e => {
                                const value = e.target.value.replace(/\D/g, '');
                                handleChange({ target: { value } }, 'identification');
                            }}
                            onInput={e => e.target.value = e.target.value.replace(/\D/g, '')}
                            error={!(!errors?.identification.error)}
                            helperText={errors?.identification.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>
                    <ContainerInput sx={{ width: '24%' }}>
                        <Label>{t('worker.table.dateIssue')}:</Label>
                        <ContainerInputsDate errorstart={errors?.identificationDate.error} >
                            <LocalizationProvider dateAdapter={AdapterDayjs} id='Loclization Date'>
                                <DemoContainer components={['DatePicker']} id='Demo Container'>
                                    <DatePicker
                                        label=''
                                        value={dayjs(form.identificationDate)}
                                        // minDate={dayjs('2020-03-20')}
                                        maxDate={dayjs()}
                                        onChange={e => handleChange(e || '', "identificationDate", "date")}
                                        slotProps={{ textField: { size: 'small', error: errors?.identificationDate.error } }}
                                        format="DD/MM/YYYY"
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </ContainerInputsDate>
                        {errors?.identificationDate?.error && (
                            <FormHelperText style={{ marginLeft: '12px' }} error={true}>{errors.identificationDate.error}</FormHelperText>
                        )}
                    </ContainerInput>
                    <ContainerInput sx={{ width: '50%' }}>
                        <Label>{t('worker.table.email')}:</Label>
                        <TextField
                            type='text'
                            value={form.email}
                            size="small"
                            onChange={e => handleChange(e, 'email')}
                            error={!(!errors?.email.error)}
                            helperText={errors?.email.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>
                </ContainerGroup>

                <ContainerGroup>
                    <ContainerInput>
                        <Label>{t('worker.table.name')}:</Label>
                        <TextField
                            value={form.name}
                            size="small"
                            onChange={e => handleChange(e, 'name')}
                            error={!(!errors?.name.error)}
                            helperText={errors?.name.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>
                    <ContainerInput>
                        <Label>{t('worker.table.lastName')}:</Label>
                        <TextField
                            value={form.lastName}
                            size="small"
                            onChange={e => handleChange(e, 'lastName')}
                            error={!(!errors?.lastName.error)}
                            helperText={errors?.lastName.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>
                </ContainerGroup>

                <ContainerGroup>

                    <ContainerInput>
                        <Label>{t('worker.table.eps')}:</Label>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '2px' }}>

                            <SelectInput
                                placeholder=""
                                onChange={(e) => handleChange(e, 'eps', 'select')}
                                value={form.eps}
                                options={arrayEps}
                                keyValue="name"
                                sx={{ width: '25%' }}
                                size="small"
                                disabled={disabled}
                            />
                            {renderIcon(form?.epsStatus)}
                        </div>

                    </ContainerInput>


                    <ContainerInput>

                        <Label>{t('worker.table.arl')}:</Label>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '2px' }}>
                            <SelectInput
                                placeholder=""
                                onChange={(e) => handleChange(e, 'arl', 'select')}
                                value={form.arl}
                                options={arrayArl}
                                keyValue="name"
                                sx={{ width: '25%' }}
                                size="small"
                                disabled={disabled}
                            />
                            {renderIcon(form?.arlStatus)}
                        </div>

                    </ContainerInput>

                </ContainerGroup>

                <ContainerGroup>
                    <ContainerInput>
                        <Label>{t('worker.table.specialty')}:</Label>
                        <SelectInput
                            placeholder=""
                            onChange={(e) => handleChange(e, 'workerRoleId', 'select')}
                            value={form.workerRoleId}
                            options={specialties}
                            keyValue="name"
                            sx={{ width: '25%' }}
                            size="small"
                            disabled={disabled}
                        />
                    </ContainerInput>
                    <ContainerInput>
                        <Label>{t('worker.table.assignations')}:</Label>
                        <SelectInput
                            placeholder=""
                            onChange={(e) => handleChange(e, 'assignations', 'select')}
                            value={form.assignations}
                            options={assignations}
                            keyValue="name"
                            sx={{ width: '25%' }}
                            size="small"
                            limitTags={5}
                            disableCloseOnSelect={false}
                            multiple={true}
                            disabled={disabled}
                        />
                    </ContainerInput>
                </ContainerGroup>

                <ContainerGroup>
                    <ContainerInput>
                        <Label>{t('worker.table.emergencyContactFullName')}:</Label>
                        <TextField
                            value={form.emergencyContactFullName}
                            size="small"
                            onChange={e => {
                                const value = e.target.value;
                                if (/^[a-zA-ZÑñ\s]*$/.test(value)) {
                                    handleChange(e, 'emergencyContactFullName');
                                }
                            }}
                            error={!(!errors?.emergencyContactFullName.error)}
                            helperText={errors?.emergencyContactFullName.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>
                    <ContainerInput>
                        <Label>{t('worker.table.emergencyContactPhone')}:</Label>
                        <TextField
                            value={form.emergencyContactPhone}
                            size="small"
                            onChange={e => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                    handleChange(e, 'emergencyContactPhone');
                                }
                            }}
                            error={!(!errors?.emergencyContactPhone.error)}
                            helperText={errors?.emergencyContactPhone.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>

                </ContainerGroup>

                <ContainerGroup>
                    {form.certificates.map((certificate) => (
						<ContainerCertificates key={certificate.id}>
							<Label>{certificate?.name ?? ""}:</Label>
							<SelectInput
								placeholder=""
								onChange={(e) => handleChangeCertificates(e, certificate.id)}
								value={certificate.selectedOptions}
								options={certificate.options}
								keyValue="name"
								sx={{ width: '25%' }}
								size="small"
								limitTags={5}
								disableCloseOnSelect={false}
								multiple={true}
								disabled={disabled}
							/>
						</ContainerCertificates>
					))}
				</ContainerGroup>

				{/* Si selecciona certificado Retie, rol técnico */}
				{isRetieTechnicalCertificate &&
					<ContainerElectricalTechnician>
						<Label>{t('worker.table.electricalTechnician')}:</Label>
						<ContainerElectricalTechnicianFields>
							<ContainerCertificates>
								<Label>{t('worker.table.class')}:</Label>
								<SelectInput
									placeholder=""
									onChange={(e) => handleChange(e, 'certificateRoleElectricalLevels', 'select')}
									value={form.certificateRoleElectricalLevels}
									options={arrayRoleElectricalLevels}
									keyValue="name"
									sx={{ width: '25%' }}
									size="small"
									limitTags={5}
									disableCloseOnSelect={false}
									multiple={true}
									error={errors?.certificateRoleElectricalLevels.error}
									disabled={disabled}
								/>
							</ContainerCertificates>

							<ContainerCertificates>
								<Label>{t('worker.table.loadPdfFile')}:</Label>
								<ContainerUpload>
									<UploadButton component="label" startIcon={<CloudUploadIcon />} sx={{ color: colors.buttonActionColor }}>
										<input type="file" accept=".pdf" hidden onChange={e => handleChangeFile(e)} />
									</UploadButton>
									<span>{form.fileName}</span>
									{errors?.fileName?.error && (
									<FormHelperText style={{ marginLeft: '12px' }} error={true}>{errors.fileName.error}</FormHelperText>
									)}
								</ContainerUpload>
							</ContainerCertificates>
					
							<ContainerCertificates/>
						</ContainerElectricalTechnicianFields>
					</ContainerElectricalTechnician>
				}

                <ContainerGroup>
                    <ContainerChecks>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <div>
                                <CustomCheckbox
                                    onChange={(e) => handleChange(e, 'authorizationPersonalData', 'check')}
                                    required={errors?.authorizationPersonalData.error}
                                    checked={form.authorizationPersonalData}
                                />
                                <Link
                                    href='https://www.buds.com.ua/images/Lorem_ipsum.pdf'
                                    target='_blank'
                                    sx={{
                                        // cursor: 'pointer',
                                        textDecoration: 'underline',
                                        textDecorationColor: 'black'
                                    }}
                                    rel='noopener noreferrer'
                                >
                                    <Label sx={{ fontWeight: 'normal', fontSize: '1.2rem', cursor: 'pointer' }}>
                                        {t('worker.authorizationPersonalData')}
                                    </Label>
                                </Link>
                            </div>
                            {errors?.authorizationPersonalData?.error && (
                                <FormHelperText style={{ marginLeft: '12px', marginTop: 0 }} error={true}>{errors.authorizationPersonalData.error}</FormHelperText>
                            )}
                        </div>
                    </ContainerChecks>
                </ContainerGroup>

            </ContainerContent>
        </ContainerBox>
    )
}